import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import dayjs from 'dayjs';
import styles from './ButtonUninstall0.module.less';

import { logging } from '../../../actions/log';
import { getLocalSoft } from '../../../actions/native';
import { setFasterProduct } from '../../../actions/layout';
import CompetitiveProduct from '../../CompetitiveProduct/CompetitiveProduct';
import { PCStoreJsBridge } from '../../../nativeapi';
import { downloadAddSoft } from '../../../actions/downloadTask';
import { fasterProductNextTime } from '../../../constants/storageKeys';
import Dialog from '../../Dialog/Dialog';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectDownloadSofts = createSelector(
  state => state.downloadTask,
  downloadTask => downloadTask.softs,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);

const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);
const selectProductRecommendInfo = createSelector(
  state => state.native,
  search => search.productRecommendInfo,
);

export default memo(({ soft, info = {}, logInfo = {}, handleUninstall = () => {} }) => {
  let cn_sbutton = styles.sbutton;
  let cn_sbutton_busing = styles.sbutton_busing;
  let cn_sbutton_open = styles.sbutton_open;
  // 按钮info传入百分比进度颜色
  let dl_progressColor = info.progressColor || '#CAF3E1';
  // 按钮info传入百分比进度将要覆盖的背景颜色
  let dl_backgroundColor = info.backgroundColor || '#ffffff00';

  const dispatch = useDispatch();

  const logInfoData = useSelector(selectLogInfo);
  const downloadSofts = useSelector(selectDownloadSofts); // 正在下载
  const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
  const installedSofts = useSelector(selectInstalledSoft); // 已经安装
  const silentInstSoft = useSelector(selectSilentInstSoft); // 支持快速静默安装的应用列表
  const isEnabledSilent = useSelector(selectIsEnabledSilent); // 是否打开快速静默安装
  const productRecommendInfo = useSelector(selectProductRecommendInfo); // 竞品引流的数据源

  const [fondSoft, setFondSoft] = useState(undefined);
  const [upgrade, setUpgrade] = useState(undefined);
  const [silentSoft, setSilentSoft] = useState(undefined);
  const [installed, setInstalled] = useState(undefined);
  const [linearGradient, setLinearGradient] = useState(
    `linear-gradient(to right, ${dl_progressColor} 0%, ${dl_backgroundColor} 0%)`,
  );
  const [modalVisible, setModalVisible] = useState(false);
  const [buttonText, setButtonText] = useState(info.text || '打开');
  const [installSoftInfo, setInstalSoftInfo] = useState(soft);
  const [hascompeteProduct, setHascompeteProduct] = useState(false);

  // 竞品引流的数据源
  useEffect(() => {
    if (
      productRecommendInfo &&
      productRecommendInfo.length > 0 &&
      soft &&
      info &&
      info.isCompetitive
    ) {
      const target = productRecommendInfo.filter(item => item.competeProductId === soft.softID);
      if (target && target.length > 0) {
        setHascompeteProduct(true);
      }
    }
  }, [productRecommendInfo, soft, info]);

  // 查询当前是否已经安装
  useEffect(() => {
    if (upgradeSofts) {
      setUpgrade(
        upgradeSofts.find(
          soft_ =>
            soft_.androidType !== '1' &&
            (soft_.softID === soft.softID || soft_.SoftID === soft.softID),
        ),
      );
    }
  }, [soft, upgradeSofts]);

  // 查询当前是否已经安装 并且是否可升级
  useEffect(() => {
    if (installedSofts) {
      setInstalled(
        installedSofts.find(
          soft_ =>
            soft_.androidType !== '1' &&
            (soft_.softID === soft.softID || soft_.SoftID === soft.softID),
        ),
      );
    }
  }, [soft, installedSofts]);

  // 查询是否打开静默安装的开关
  // 查询当前是否已经安装 并且是否可升级
  useEffect(() => {
    if (silentInstSoft && isEnabledSilent) {
      setSilentSoft(silentInstSoft.find(soft_ => soft_.softID === soft.softID));
    }
  }, [soft, silentInstSoft, isEnabledSilent]);

  // 更新按钮显示状态
  useEffect(() => {
    let linear_Gradient = `linear-gradient(to right, ${dl_backgroundColor} 0%, ${dl_backgroundColor} 0%)`;
    let button_Text = info.text || '打开';
    const found =
      downloadSofts &&
      downloadSofts.find(
        soft_ =>
          soft_.type === 'pc' &&
          (soft_.pc.SoftID === soft.softID ||
            soft_.pc.SoftID === soft.SoftID ||
            soft_.pc.SoftID === soft.softId),
      );
    // 正在任务中...
    if (found && found.pc && found.pc.SoftID) {
      if (found.attr.status === 'pre') {
        button_Text = '准备中';
      } else if (found.attr.status === 'wait') {
        button_Text = '等待中';
      } else if (found.attr.status === 'pause') {
        button_Text = '继续';
        linear_Gradient = `linear-gradient(to right, ${dl_progressColor} ${found.attr.progress ||
          0}%, ${dl_backgroundColor} ${found.attr.progress || 0}%)`;
      } else if (found.attr.status === 'dl') {
        button_Text = `${found.attr && found.attr.progress ? found.attr.progress.toFixed(0) : 0}%`;
        linear_Gradient = `linear-gradient(to right, ${dl_progressColor} ${found.attr.progress ||
          0}%, ${dl_backgroundColor} ${found.attr.progress || 0}%)`;
      } else if (found.attr.status === 'i') {
        button_Text = '安装中';
        linear_Gradient = `linear-gradient(to right, ${dl_progressColor} 0%, ${dl_backgroundColor} 0%)`;
      } else if (found.attr.status === 'exitq') {
        // // 安装完成重新获取一次本地列表
        // dispatch(getLocalSoft());
      } else if (found.attr.status === 'err') {
      }
    } else if (installed) {
      button_Text = '打开';
    }

    if (buttonText !== button_Text) {
      setButtonText(button_Text);
    }
    if (linearGradient !== linear_Gradient) {
      setLinearGradient(linear_Gradient);
    }
    setFondSoft(found || undefined);
  }, [dispatch, soft, downloadSofts, upgrade, installed, silentSoft, isEnabledSilent]);

  // 加速器
  const handelFaster = () => {
    const now = dayjs(Date.now()).format('YYYYMMDD');
    const nextPopTime = localStorage.getItem(fasterProductNextTime);
    if ((!nextPopTime || +now >= +nextPopTime) && soft && soft.appRecommend) {
      dispatch(
        setFasterProduct({
          soft,
          info,
          logInfo,
          record: true, // 传递这个值 会记录下次弹出时间
        }),
      );
    }
  };

  const handleCancelModal = useCallback(() => {
    setModalVisible(false);
  });

  // 获取生成打桩参数
  const getLogParam2 = useCallback(
    (soft_info, logInfo_para) => {
      const logParam2 = {
        source: logInfo_para.source,
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: soft_info.softID,
        softName: soft_info.softName,
        softType: '0', // 安卓(1)还是PC(0)应用
        type: upgrade ? 'u' : 'd', // 更新还是下载
        url: soft_info.downLoadUrl,
      };
      // 当为搜索结果也跳转过来的，带上附加信息
      // search_type 1: 热词  2: 联想词  3: 搜索词  4: 联想词 首位应用  5: 热词应用  6: 联想词 非首位应用
      if (logInfo_para.isSearch) {
        logParam2.search_type = logInfoData.search_type;
        logParam2.search_word = logInfoData.search_word;
        logParam2.lenovo_bizinfo = logInfo_para.lenovo_bizinfo || logInfoData.lenovo_bizinfo;
      }
      // 联想词softcard  做特殊处理 参数通过 logInfo (即logInfo_para) 传入
      if (
        logInfo_para.isSearch &&
        (logInfo_para.search_type === 4 ||
          logInfo_para.search_type === 5 ||
          logInfo_para.search_type === 6)
      ) {
        logParam2.source_p = logInfo_para.source_p;
        logParam2.source_pp = logInfo_para.source_pp;
        logParam2.search_type = logInfo_para.search_type;
        logParam2.search_word = logInfo_para.search_word;
        logParam2.lenovo_bizinfo = logInfo_para.lenovo_bizinfo || logInfoData.lenovo_bizinfo;
      }
      // 处理命令行直接跳入搜索结果页面没有search_word的问题
      if (logInfo_para.isSearch && logInfo_para.search_word) {
        logParam2.search_word = logInfo_para.search_word;
      }
      return logParam2;
    },
    [logInfoData, upgrade],
  );

  // 点击按钮处理
  const handleInstallSoft = useCallback(
    (soft_info, button_Text, logInfo_para, fond_soft) => {
      //   if (!soft_info.softID || !soft_info.SoftID) {
      //     return;
      //   }
      // const logParam2 = getLogParam2(soft_info, logInfo_para);
      const logParam2 = {
        source: 'Mysofts',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        softid: soft_info.softID ?? '',
        softName: soft_info.softName,
        softType: 'o',
        url: soft_info.downLoadUrl || soft_info.downloadUrl,
        type: 'd',
      };
      // 获取静默安装参数
      let installparams = null;
      if (
        isEnabledSilent &&
        silentSoft &&
        silentSoft.softID === (soft_info.softID ?? soft_info.SoftID)
      ) {
        installparams = {};
        logParam2.type = upgrade ? 'xu' : 'xd';
        if (silentSoft.silentParamDic) {
          installparams.quiet = silentSoft.silentParamDic;
        }
        if (silentSoft.silentDirParamDic) {
          installparams.todir = silentSoft.silentDirParamDic;
        }
      }

      let isNeedLog = false;
      const softInfo = { ...soft_info, logInfo: logParam2, installparams };
      // 正常安装
      if (button_Text === '安装' || button_Text === '升级' || button_Text === '快装') {
        // // 竞品引流
        // if (hascompeteProduct && button_Text !== '升级') {
        //   setInstalSoftInfo(softInfo);
        //   setModalVisible(true);
        // } else {
        //   // 判断是否需要弹出下载加速器弹框
        //   if (info.isFasterProduct && button_Text !== '升级') {
        //     handelFaster();
        //   }

        // }
        // 添加下载任务
        dispatch(downloadAddSoft(softInfo));

        isNeedLog = true;
      }
      // // 正在下载中，点击暂停
      // if (fond_soft && fond_soft.attr && fond_soft.attr.status === 'dl') {
      //   logParam2.isPause = '1';
      //   PCStoreJsBridge.downloadPause({ ...fond_soft });
      //   isNeedLog = true;
      // }
      // 正在暂停中，点击继续
      if (fond_soft && fond_soft.attr && fond_soft.attr.status === 'pause') {
        logParam2.isPause = '0';
        PCStoreJsBridge.downloadResume({ ...fond_soft });
        isNeedLog = true;
      }
      if (button_Text === '打开') {
        logParam2.softType = '0';
        logParam2.softid = softInfo.SoftID;
        logParam2.softName = softInfo.displayName;
        // logParam2.type = 'o';
        // 打开前判断文件是否能正常打开
        PCStoreJsBridge.openSoftDetermine(soft_info).then(res => {
          if (res?.AppExist) {
            PCStoreJsBridge.openSoft(soft_info);
          } else {
            setModalVisible(true);
            dispatch(
              logging({
                category: 'P',
                action: 'Fail_Open',
                label: '',
                param2: {
                  source: 'Mysofts',
                  source_p: logInfoData.source_p,
                  source_pp: logInfoData.source_pp,
                  softid: soft_info.softID ?? soft_info.SoftID ?? '',
                  guid: soft.softGUID,
                },
              }),
            );
          }
        });
        isNeedLog = true;
      }

      // 按钮点击打桩
      if (isNeedLog) {
        dispatch(
          logging({
            category: 'C',
            action: 'Mysofts_Open',
            label: '',
            param2: logParam2,
            param3: soft_info.bizInfo || null,
          }),
        );
      }
      //
    },
    [dispatch, installed, silentSoft, isEnabledSilent, hascompeteProduct],
  );

  const handleDownloadSoft = soft_info => {
    const logParam2 = {
      source: 'Mysofts_Fail_Open',
      source_p: logInfoData.source_p,
      source_pp: logInfoData.source_pp,
      softid: soft_info.softID ?? soft_info?.SoftID ?? '',
      softName: soft_info.softName,
      softType: 'o',
      url: soft_info.downLoadUrl || soft_info.downloadUrl,
      type: 'd',
    };
    // 获取静默安装参数
    let installparams = null;
    if (
      isEnabledSilent &&
      silentSoft &&
      silentSoft.softID === (soft_info.softID ?? soft_info.SoftID)
    ) {
      installparams = {};
      logParam2.type = upgrade ? 'xu' : 'xd';
      if (silentSoft.silentParamDic) {
        installparams.quiet = silentSoft.silentParamDic;
      }
      if (silentSoft.silentDirParamDic) {
        installparams.todir = silentSoft.silentDirParamDic;
      }
    }
    const softInfo = { ...soft_info, logInfo: logParam2, installparams };
    dispatch(
      logging({
        category: 'C',
        action: 'Fail_Open_Reinstall',
        label: '',
        param2: {
          softid: soft_info.softID ?? soft_info?.SoftID ?? '',
          guid: soft_info?.softGUID,
          source: 'Mysofts_Fail_Open',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(downloadAddSoft(softInfo));
  };

  return (
    <>
      <div
        style={
          fondSoft && fondSoft.attr && fondSoft.attr.status && linearGradient
            ? { backgroundImage: linearGradient }
            : {}
        }
        className={
          fondSoft && fondSoft.attr
            ? `${styles.button} ${cn_sbutton_busing} ${info.className_busing || ''}`
            : `${styles.button}
            ${cn_sbutton}
            ${info.className || ''}
            ${buttonText === '打开' && `${cn_sbutton_open} ${info && info.className_open}`}`
        }
        onClick={e => {
          e.preventDefault();
          info?.disable ? '' : handleInstallSoft(soft, buttonText, logInfo, fondSoft);
        }}
      >
        {buttonText}
      </div>

      {/* {modalVisible && (
        <CompetitiveProduct
          visible={modalVisible}
          softInfo={{
            ...installSoftInfo,
            SoftID: installSoftInfo.softID || installSoftInfo.SoftID,
          }}
          handleCancel={handleCancelModal}
          logInfo={logInfo}
          button_Text={buttonText}
        />
      )} */}
      {modalVisible && (
        <Dialog
          maskStyle={styles.mask}
          containerStyle={
            soft?.softID || soft?.SoftID ? styles.force_delete : styles.force_small_delete
          }
          handleClose={() => setModalVisible(false)}
          title="温馨提示"
        >
          {(soft?.softID || soft?.SoftID) && (
            <>
              <div className={styles.message}>该应用已无法打开，您可以卸载该应用或重新安装</div>
              <div className={styles.btn_operation}>
                <div
                  className={styles.btn}
                  onClick={() => {
                    dispatch(
                      logging({
                        category: 'C',
                        action: 'Fail_Open_Uninstall',
                        label: '',
                        param2: {
                          source: 'Mysofts',
                          source_p: logInfoData.source_p,
                          source_pp: logInfoData.source_pp,
                          softid: soft?.softID ?? soft?.SoftID ?? '',
                          guid: soft.softGUID,
                        },
                      }),
                    );
                    handleUninstall();
                    setModalVisible(false);
                  }}
                >
                  卸载
                </div>
                <div
                  className={styles.btn_create}
                  onClick={() => {
                    handleDownloadSoft(soft);
                    setModalVisible(false);
                  }}
                >
                  重新安装
                </div>
              </div>
            </>
          )}
          {!soft?.softID && !soft?.SoftID && (
            <>
              <div className={styles.small_message}>该应用已无法打开，您可以卸载该应用。</div>
              <div className={styles.btn_operation}>
                <div
                  className={styles.btn_create}
                  onClick={() => {
                    dispatch(
                      logging({
                        category: 'C',
                        action: 'Fail_Open_Uninstall',
                        label: '',
                        param2: {
                          source: 'Mysofts',
                          source_p: logInfoData.source_p,
                          source_pp: logInfoData.source_pp,
                          softid: soft.softID ?? '',
                          guid: soft.softGUID,
                        },
                      }),
                    );
                    handleUninstall();
                    setModalVisible(false);
                  }}
                >
                  卸载
                </div>
              </div>
            </>
          )}
        </Dialog>
      )}
    </>
  );
});
